module.exports = __webpack_public_path__ + "static/img/036 4.d01becff.jpg";